import React, { Component } from 'react';
import { Modal, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import FormList from '../../../basicElement/FormList';

class AddBa extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    show = () => {
        this.setState({
            data: {},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        const { value: id, text: name } = value;
        data.baId = id;
        data.baName = name;
        this.setState({ data });
    }

    getColumns = () => {
        const { data } = this.state;

        // 字段属性配置
        const columns = [{
            name: 'BA',
            key: 'baName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'baPersonNameCode',
                style: { width: 160 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20 },
                url: API_URL.contract.queryBaByNameCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user', type: 'baGrouping' },
            },
            rules: {
                required: true,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = true;
                typeProperty.value = data[key];
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.insertBA, {
            ...data,
        }).then(res => {
            message.success('添加BA成功');
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                title="添加BA"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal"
                maskClosable={false}
                width="400px"
            >
                <FormList
                    className="form-list fortyPercent"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
            </Modal>
        );
    }
}

export default AddBa;


// WEBPACK FOOTER //
// ./src/components/contractManagement/baGrouping/components/AddBa.js